/*
 * Copyright (c) 2019. World Wide Generation Ltd
 */

import { UtrvStatus } from '@constants/status';
import { DocumentItem } from '@g17eco/types/document';
import { ExistingEvidenceFile } from '@g17eco/types/file';

interface EvidenceLinkProps {
  link: string;
}

export const EvidenceLink = (props: EvidenceLinkProps) => {
  const { link } = props;

  if (typeof link === 'string' && link.startsWith('http')) {
    return (
      <a href={link} target={'_blank'} rel='noopener noreferrer'>
        {link}
      </a>
    );
  }

  return link;
};

export const mapDocumentsToEvidenceFiles = (docs: DocumentItem[]): ExistingEvidenceFile[] => {
  return docs.map((doc) => ({
    _id: doc._id,
    metadata: doc.metadata,
    type: 'file',
    userId: doc.userId,
    path: doc.path,
    size: doc.size,
    status: UtrvStatus.Updated, // to allow remove evidence to be added
    public: doc.public,
    created: doc.created,
    url: doc.url,
    ownerSubType: doc.ownerSubType,
    ownerId: doc.ownerId,
    ownerType: doc.ownerType,
    aiProcessing: doc.aiProcessing,
  }));
};